var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"job-complete-validator-tag"},[_vm._v("\n\t"+_vm._s(_vm.validJobInfo.completedCount)+" / "+_vm._s(_vm.validJobInfo.totalJobsCount)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2fb108e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/three-sixty-evaluation/commons/job-complete-validator-tag.vue
// module id = 3225
// module chunks = 9